export default __webpack_public_path__ + "static/media/rain-background.82ef5deb.jpg";